import { render, staticRenderFns } from "./MantenedorTransbankPantalla.vue?vue&type=template&id=5aa6de26&"
import script from "./MantenedorTransbankPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTransbankPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports